
import { Vue } from "vue-class-component";

export default class PageFooter extends Vue {}
